import { render, staticRenderFns } from "./clipboard-display.vue?vue&type=template&id=5607f4c7&scoped=true&"
import script from "./clipboard-display.vue?vue&type=script&lang=ts&"
export * from "./clipboard-display.vue?vue&type=script&lang=ts&"
import style0 from "./clipboard-display.vue?vue&type=style&index=0&id=5607f4c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5607f4c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
